import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as flexBoxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';

export const templateGridFooter = document.createElement('template');

templateGridFooter.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${flexBoxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
       <gz-button id="backToTop" class="back-to-top" type="quiet" color="secondary" buttonHeight="small" buttonFontSize="small" lowercase></gz-button>

       <gz-grid-summary id="gridSummary"></gz-grid-summary>

       <div class="load-more-wrapper d-flex flex-row justify-center">
            <gz-button id="loadMore" class="load-more" type="quiet" color="secondary"></gz-button>
            <gz-dropdown listPosition="top" id="loadItemsCount" class="load-items-count"></gz-dropdown>
      </div>

    <gz-pagination id="paginationFooter" class="pagination-footer"></gz-pagination>
    <gz-icon-button
        id="gridDataRefresh"
        class="grid-refresh"
        icon="ds-icon-refresh"
        size="24"
        fontsize="20"
        buttontype="square"
        buttonfill="quiet"
        buttoncolor="secondary">
    </gz-icon-button>
</div>
`;
